var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.routeFormated)?_c('div',{staticClass:"box-breadcrumbs mb-3"},[_c('div',{staticClass:"mtx-breadcrumbs",domProps:{"innerHTML":_vm._s(_vm.routeFormated)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }